import { useEffect, useState } from 'react';
import { useT } from '../app/preferences.ts';
import { useTestAd } from '../lib/ads.ts';
import { Dialog } from './Dialog.tsx';

/** Stand-in for a real ad in development builds without an AdSense id. */
export function TestAdDialog() {
  const t = useT();
  const ad = useTestAd();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!ad) return;
    const id = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(id);
  }, [ad]);

  const left = ad ? Math.max(0, Math.ceil((ad.endsAt - now) / 1000)) : 0;

  return (
    <Dialog
      open={ad !== null}
      onClose={() => ad?.finish('dismissed')}
      title={t('ads.test.title')}
      footer={
        <>
          <button type="button" className="btn" onClick={() => ad?.finish('dismissed')}>
            {t('ads.test.close')}
          </button>
          <button type="button" className="btn btn-primary" disabled={left > 0} onClick={() => ad?.finish('viewed')}>
            {left > 0 ? t('ads.test.wait', { n: left }) : t('ads.test.claim')}
          </button>
        </>
      }
    >
      <div className="dialog-body test-ad">
        <span className="emoji" aria-hidden="true">
          🎬
        </span>
        <p>{t('ads.test.body')}</p>
      </div>
    </Dialog>
  );
}
